module.exports = __webpack_public_path__ + "img/image00001-min.e66fba7c.jpg";